import { IconExpand } from 'chat-components/ui/icon';
import { IconMinimize } from 'chat-components/ui/icon';
import VisualCardView from 'components/DashboardVisual/VisualCardView';
import VisualGraphView from 'components/DashboardVisual/VisualGraphView';
import VisualGridView from 'components/DashboardVisual/VisualGridView';
import VisualPieChartView from 'components/DashboardVisual/VisualPieChartView';
import CustomSpinner from 'components/Misc/CustomSpinner';
import { MainContext } from 'context/mainContext';
import GraphView from 'eva-component/response/GraphView';
import GridView from 'eva-component/response/GridView';
import TreeView from 'eva-component/response/TreeView';
import { IconClose } from 'eva-component/ui/icon';
import React, { useContext, useEffect, useState } from 'react'
import { useCallback } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Button, Col, CustomInput, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { decryptAndDecompress } from 'services/DashboardService';
import { validateAndReplaceNulls } from 'services/DashboardService';
import { removeDashboardDataStorage } from 'services/DashboardService';
import { dashboardDataStorage } from 'services/DashboardService';
import { submitEvaQueryHandler } from 'services/DashboardService';
import { ProcessEditedExcelGrid } from 'services/EVADataService';
import { ProcessGrandParentRow } from 'services/EVAEditGridService';
import { UpdateCellWithFormula } from 'services/EVAEditGridService';
import { ProcessSQLGroupWithTotal } from 'services/EVAEditGridService';
import { ProcessRemoveRow } from 'services/EVAEditGridService';
import { GetCellIdValue } from 'services/EVAEditGridService';
import { PopulateNewRows } from 'services/EVAEditGridService';
import { ProcessDnDTreeviewData } from 'services/EVAEditGridService';
import { ProcessGroupWithTotal } from 'services/EVAEditGridService';
import { ProcessGrandTotal } from 'services/EVAEditGridService';
import { ProcessRenamingSQLData } from 'services/EVAEditGridService';
import { RecalculateWithTotal } from 'services/EVAEditGridService';
import { TransformSQLResult } from 'services/EVAEditGridService';
import { ProcessEditedGridCellData } from 'services/EVAEditGridService';
import { PopulateNewEVAResponseFormat } from 'services/EVAResponseService';
import { evaThemeLighter } from 'services/EVAResponseService';
import { reFormatEVADateRange } from 'services/EVAResponseService';
import { isWithChildHandler } from 'services/EVAResponseService';
import { convertToTreeViewData } from 'services/EVAResponseService';
import { getRandomLightColor } from 'services/EVAService';
import { defaultControl } from 'services/EVAVisualService';
import { processGridView } from 'services/EVAVisualService';
import { processCardView } from 'services/EVAVisualService';
import { processPieGraph } from 'services/EVAVisualService';
import { processGraphView } from 'services/EVAVisualService';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { RunDataConversionService } from 'services/EVADataService';
import { IconEdit } from 'eva-component/ui/icon';

export default function DashboardTemplateItemModal({ name, query , index, item, layoutsWithId, selectedTemplateItem, onEditVisual, 
    handleCloseEditVisual, handleIsWithError, onHandleEditVisual, newUpdateCount, evaDateFilters, handleGridHeaderChange, handleDateRangesUpdate  }) {
    const [isShowGrid, setIsShowGrid] = useState(false)
    const [isShowGrap, setIsShowGrap] = useState(false)
    const { bgColor, textColor, userDetails, firmDetails, 
        selectedClientID, 
        selectedClient, 
        integrationLastRefreshList,        
        templateFinalSelectedTemplateItem, 
        setTemplateFinalSelectedTemplateItem } = useContext(MainContext);
    const [toggleAll, setToggleAll] = useState(false)
    const [sqlresult, setSqlResult] = useState(null)
    const [gridHeader, setGridHeader] = useState(null)
    const [gridHeaderWithDateRange, setGridHeaderDateRange] = useState(null)
    const [gridOriginalHeader, setOriginalGridHeader] = useState(null)
    const [EVAData, setEVAData] = useState(null)
    const [treeViewData, setTreeViewData] = useState(null)
    const [isWithChild, setIsWithChild] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isError, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [queryResult, setQueryResult] = useState(null)
    const [visualType, setVisualType] = useState(null)
    const [visualData, setVisualData] = useState(null)
    const [selectedViewOption, setSelectedViewOption] = useState('Grid')
    const [headerToMultiSelect, setHeaderToMultiSelect] = useState([])
    const [templateItemVisual, setTemplateItemVisual] = useState(null)
    const [refreshQuery, setRefreshQuery] = useState(0);
    const [dataValue, setDataValue] = useState(null)
    const [groupLevel, setGroupLevel] = useState(null)
    const [evaQuery, setEVAQuery] = useState(null)
    const [isEditDateRange, setIsEditDateRange] = useState(false)
    const [alert, setAlert] = useState(false);
    const [layout, setLayout] = useState({})
    const viewOption = ['Grid', 'Card', 'Pie Chart', 'Line Chart', 'Bar Chart']

    const theme = { PrimaryColor: bgColor, TextColor: textColor }
    const [isMounted, setIsMounted] = useState(true);

    useEffect(() => {
        setIsMounted(true);
        return () => {
            setIsMounted(false); // Cleanup when component unmounts
        };
    }, []);

    useEffect(() => {
        if (!layout) return
        if (Object.keys(layout).length === 0) return 

        if(item.tempVisual)
        {
            item.tempVisual.width =  layout.w;
            item.tempVisual.height =  layout.h;
            item.tempVisual.x =  layout.x;
            item.tempVisual.y =  layout.y;
        } else if(item.visual) {
            item.visual.width = layout.w;
            item.visual.height = layout.h;
            item.visual.x = layout.x;
            item.visual.y = layout.y;
        }
    },[layout])

    useEffect(() => {
        const processData = async () => {
            try{
                if(item.visual_type === "Card" && item.cleanedHeader.length > 1)
                { 
                    setTemplateItemVisual(item.tempVisual)
                    setGridHeader(item.cleanedHeader)
                    setSqlResult(item.sqlresult)
                    setGridHeaderDateRange(item.gridHeaderDateRange)
                    setLoading(false)
                    return
                }
                setLoading(true)
                let res;
                if (layoutsWithId && Array.isArray(layoutsWithId.lg)) {
                    const newLayout = layoutsWithId.lg.find(i => i.my_row_id === item.my_row_id);
                    setLayout(newLayout);
                }
                const lastRefreshData = integrationLastRefreshList.find(i => i.integration === item.integration)
                const refreshDate = lastRefreshData?.lastRefresh ?? new Date().toLocaleString();
                const cached = dashboardDataStorage(item, refreshDate);
                if (cached) {
                    res = cached;
                } else {
                    if (item.stext !== undefined) {
                        const decryptedText = await decryptAndDecompress(item.stext);
                        res = await submitEvaQueryHandler(decryptedText, selectedClient, firmDetails, userDetails, item, index);
                    } else 
                        res = await submitEvaQueryHandler(evaQuery || item.dynamic_query, selectedClient, firmDetails, userDetails, item, index);
                }
                
                if(res && res.columns) {
                    const cleanedHeader = res.columns.map(h => h.replace(/\s*\[.*?\]/g, ''));
                    setGridHeader(cleanedHeader)
                    setGridHeaderDateRange(res.columns)
                    setOriginalGridHeader(res.columns)
                    setLoading(false);
                    setSelectedViewOption('Grid')
                    return
                }

                if(!res || res === undefined || (res && res[0] && res[0].error)) {
                    setErrorMessage(res && res[0] && res[0].error ? res[0].error : 'Something went wrong')
                    setError(true)
                    setLoading(false);
                    handleIsWithError(true)
                    return
                }
                
                validateVisualData()

                setQueryResult(res)
                let sqlresult = res.map(obj => Object.values(obj));
                
                if (dateRanges.length === 0 && !cached) { //&& sqlresult.length <= 250) {
                    dashboardDataStorage(item, refreshDate, res);
                }

                if(sqlresult.length > 100) 
                {
                    setToggleAll(true)
                    sqlresult = sqlresult.slice(0, 100);
                }

                const OriginalSQLresult = res.map(obj => Object.values(obj));
                validateAndReplaceNulls(sqlresult)
                const header = res.length > 0 ? Object.keys(res[0]) : [];
                const cleanedHeader = header.map(h => h.replace(/\s*\[.*?\]/g, ''));

                const newRes = await reFormatEVADateRange(header, sqlresult)
                if(newRes.dataValue.length > 0)
                {
                    processDataValue(newRes.dataValue)
                }
                
                setDataValue(newRes.dataValue)
                const treeViewData = convertToTreeViewData(sqlresult)
                const isWithChild = isWithChildHandler(treeViewData)
                const { result, groupLevel } = await RunDataConversionService(sqlresult, cleanedHeader);
                const newResult = ProcessSQLGroupWithTotal(result, cleanedHeader, groupLevel)
                const isCumulative = item.dynamic_query.includes("cumulative")
                
                let visualData;
                try {
                    visualData = typeof item.visual_data === 'string'
                        ? JSON.parse(item.visual_data)
                        : item.visual_data;
                } catch (e) {
                    console.error('Invalid JSON:', item.visual_data);
                    visualData = null;
                }
                setVisualData(visualData)
                setEVAData(res)
                setSqlResult(sqlresult)
                setGridHeader(cleanedHeader)
                setGridHeaderDateRange(header)
                setOriginalGridHeader(cleanedHeader)

                let newTreeData 
                if(sqlresult.length > 500) newTreeData = await PopulateNewEVAResponseFormat(sqlresult, header)
                else newTreeData = await RunDataConversionService(sqlresult, header)

                setGroupLevel(isCumulative ? 1 : newTreeData.groupLevel)
                setIsWithChild(newTreeData.isWithChild)
                
                if(item.editedGridCellData)
                {
                    const res = await ProcessEditedExcelGrid(item.editedGridCellData, sqlresult, header)
                    setTreeViewData(res.treeData)
                    setGridHeader(res.header);
                } else if (sqlresult.length === 1) {
                    setTreeViewData(newTreeData.result)
                } else {
                    setTreeViewData(isCumulative ? newTreeData.result : newTreeData.resultWithGrandTotal)
                }

                setIsWithChild(isWithChild)
                handleIsWithError(false)
                setLoading(false)
                setError(false)
            
                if(item.visual_type && item.visual_data)
                    processDefaultView(sqlresult, item.visual_type)

                if(item.dynamic_query) {
                    item.final_dynamic_query = evaQuery || item.dynamic_query
                }
                    
            }catch (error)
            {
                console.log(error)
                setError(true)
                setLoading(false);
            }
        }
        processData();
    }, [query, newUpdateCount, evaQuery, integrationLastRefreshList, layoutsWithId])

    const validateVisualData = () => {
        return
        if(item.visual_data && item.visual_data.dataValue && Array.isArray(item.visual_data.dataValue))
        {
            const currentYear = new Date().getFullYear(); // Get current year

            item.visual_data.dataValue = item.visual_data.dataValue.map(value => {
                return value.replace(/FY\d{4}/, `FY${currentYear}`); // Replace any "FYXXXX" with "FY2024"
            });
        }
    }
    const processEditedGridCellData = (item, sqlresult, gridHeader) => {
        if(item && item.editedGridCellData)
        {
            const { gridGroupLevel, newRowList, dragAndDropData, cellFormulaList, renamedSQLData, hiddenRow, renamedHeaderList, addedColumnList } = item.editedGridCellData
            let header = gridHeader
            let sqlData = sqlresult
            let updatedNewRowList = newRowList

            const processNewHeader = (columnHeader, sqlData, newRowList) => {
                let header = [...columnHeader];
                let updatedData = [...sqlData];
                let updateRowList = JSON.parse(JSON.stringify(newRowList));
            
                if (addedColumnList.length > 0) {
                    addedColumnList.map(item => {
                        header.push(item.name);
                        addZeroToRow(updateRowList);
                    });
                    updatedData = sqlData.map(item => [...item, 0]);
                }
            
                function addZeroToRow(updateRowList) {
                    for (let i = 0; i < updateRowList.length; i++) {
                        const row = updateRowList[i];
                        if (row.value) row.value = [...row.value, 0];
                        if (row.children) addZeroToRow(row.children);
                    }
                }
                return { header, updatedData, updateRowList };
            };
            
            if(addedColumnList) {
                const headerData = processNewHeader(gridHeader, sqlData, newRowList);
                header = headerData.header
                sqlData = headerData.updatedData
                updatedNewRowList = headerData.updateRowList
            }

            if(renamedHeaderList) header = ProcessColumnRename(renamedHeaderList, header)
            
            let treeData = []

            treeData = TransformSQLResult(sqlData, header, gridGroupLevel)
           

            treeData = PopulateNewRows(updatedNewRowList, sqlData, header, gridGroupLevel)

            if(dragAndDropData.length > 0) 
            {
                treeData = ProcessDnDTreeviewData(dragAndDropData, treeData)
                const isWithGroup = dragAndDropData.filter(g => g.parentId && g.parentId.includes("-group-"))
                if(isWithGroup.length > 0)
                {
                    treeData = RecalculateWithTotal(treeData)
                }
            }

            let cellValue = GetCellIdValue(treeData)


            treeData = ProcessGroupWithTotal(treeData, cellValue, header, gridGroupLevel, cellFormulaList)
        
            const processRenaming = (treeData) => {
                if (renamedSQLData && renamedSQLData.length > 0) {
                    return ProcessRenamingSQLData(renamedSQLData, treeData);
                }
                return treeData;
            };
     
            treeData = ProcessGrandTotal(treeData, cellValue, updatedNewRowList, header, gridGroupLevel, cellFormulaList)
            cellValue = GetCellIdValue(treeData)
            treeData = ProcessGrandParentRow(updatedNewRowList, treeData)
            treeData = processRenaming(treeData);
            treeData = ProcessRemoveRow(treeData, hiddenRow)
            if(cellFormulaList) {
                cellValue = GetCellIdValue(treeData)
                treeData = UpdateCellWithFormula(treeData, cellValue, cellFormulaList)
            }

            return treeData
        }
        return null
    }
    const ProcessColumnRename = (renamedHeaderList, gridHeader) => {
        if (renamedHeaderList?.length === 0 || !renamedHeaderList)
        { 
            setGridHeader(gridHeader);
            return gridHeader
        }

        const newColumnHeader = [...gridHeader]

        renamedHeaderList && renamedHeaderList.map((item, index) => {
            newColumnHeader[item.colIndex] =  item.newHeader
        })

        setGridHeader(newColumnHeader);
        return newColumnHeader
    }
    
    useEffect(() => {
        const loadData = async () => {            
            if(!item?.tempVisual && item.visual) item.tempVisual = item.visual

            if(layout === undefined && !gridHeaderWithDateRange) return
            
            if((item.visual_type && (item.visual_type ==='Card' || item.visual_data)) || (item.tempVisual || item.tempVisual))
            {    
                processDefaultVisual(item, layout, gridHeaderWithDateRange)
            }
        }
        loadData();
    },[layout, newUpdateCount, gridHeaderWithDateRange])

    useEffect(() => {
        if(templateItemVisual && sqlresult) setSelectedViewOption(templateItemVisual.selectedViewOption)
    },[templateItemVisual])

    const processDataValue = (dataValue) => {
        // console.log({dataValue, item })
        if(dataValue.length > 0 && item.visual)
        {   
            switch(item.visual.selectedViewOption) 
            {
                case "Pie Chart":
                    break;
                case "Bar Chart":
                    dataValue.map((e,i) => {
                        item.visual.selectedGroups[i].label = e
                        item.visual.selectedGroups[i].data = e
                    })
                    break;
                case "Line Chart":
                    
                    dataValue.map((e,i) => {
                        item.visual.selectedGroups[i].label = e
                        item.visual.selectedGroups[i].data = e
                    })
                    break;
                case "Card":
                    dataValue.map((e,i) => {
                        item.visual.cardItem[i].column = e
                        item.visual.cardItem[i].column = e
                        item.visual.cardItem[i].columnToSum = e
                        item.visual.cardItem[i].columnToSum = e
                        item.visual.headerToMultiSelect[i].name = e
                        item.visual.headerToMultiSelect[i].name = e
                    })
                    break;
            }
        }else if(dataValue.length > 0 && item.visual === undefined && item.visual_type !== 'Card' && item.visual_type !== 'Grid')
        {
            item.visual_data.dataValue = dataValue[0]
        }
    }
    const processDefaultVisual = (item, layout, gridHeader) => {
        if (!gridHeader) return;
        if(!sqlresult) return;

        const headerToMultiSelect = gridHeader.map((data, index) => ({
            id: index,
            name: data.replace(/\s*\[.*?\]/g, ''),
        }));
    
        setHeaderToMultiSelect(headerToMultiSelect);

        if (visualData || item.visual || visualType || item.visual_type) {
            if (item.visual && !item.tempVisual) {
              
                item.tempVisual = item.visual;
                setTemplateItemVisual(item.tempVisual);
                setSelectedViewOption(item.tempVisual.selectedViewOption);
            } else {
                const selectedViewOption = item.tempVisual?.selectedViewOption ?? item.visual_type;
                setSelectedViewOption(selectedViewOption);
            }
    
            const viewOption = item.tempVisual?.selectedViewOption ?? item.visual?.selectedViewOption ?? item.visual_type;
            switch (viewOption) {
                case 'Bar Chart':
                    const barVisual = processGraphView(item, layout, headerToMultiSelect, visualData, dataValue, gridHeader);
                    item.tempVisual.selectedViewOption = viewOption
                    setTemplateItemVisual(barVisual);
                    break;
                case 'Line Chart':
                    const graphVisual = processGraphView(item, layout, headerToMultiSelect, visualData, dataValue, gridHeader);
                    item.tempVisual.selectedViewOption = viewOption
                    setTemplateItemVisual(graphVisual);
                    break;
                case 'Pie Chart':
                    const pieVisual = processPieGraph(item, layout, headerToMultiSelect, visualData, dataValue);
                    item.tempVisual.selectedViewOption = viewOption
                    setTemplateItemVisual(pieVisual);
                    break;
                case 'Card':
                    // const cardVisual = processCardView(item, layout, headerToMultiSelect, visualData, sqlresult, gridHeader);
                    // item.tempVisual.selectedViewOption = viewOption
                    // setTemplateItemVisual(cardVisual);
                    setTemplateItemVisual(item.tempVisual); // individual card dimension feature
                    break;
                case 'Grid':
                    const gridVisual = processGridView(item, layout, headerToMultiSelect, visualData);
                    item.tempVisual.selectedViewOption = viewOption
                    setTemplateItemVisual(gridVisual);
                    break;
                default:
                    const defaultVisual = processGridView(item, layout, headerToMultiSelect, visualData);
                    item.tempVisual.selectedViewOption = 'Grid'
                    setTemplateItemVisual(defaultVisual);
                    break;
            }
        } else {
            // console.log(item);
            const defaultVisual = processGridView(item, layout, headerToMultiSelect, visualData, sqlresult, gridHeader);
            item.tempVisual.selectedViewOption = 'Grid'
            setSelectedViewOption('Grid');
            setTemplateItemVisual(defaultVisual);
        }
    };
    
    const processDefaultView = (sqlresult, visual_type) => 
    {
        setVisualType(capitalize(visual_type))
        setSelectedViewOption(capitalize(visual_type))
    }
    const capitalize = (str) => {
        return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    };
    const handleSelectViewOption = (item) => {
        setSelectedViewOption(item)
    }
    const handleSaveVisual = (param) => {
        param.height = item.tempVisual?.height
        param.width = item.tempVisual?.width
        param.x = item.tempVisual?.x
        param.y = item.tempVisual?.y
        // item.visual = param
        item.tempVisual = param
        console.log(item)
        const newItem = { ...item };
        // console.log(newItem)
        // setTemplateItemVisual(param)
       
        handleCloseEditVisual()
        // registerDashboardTemplate(selectedDashboardTemplate)
        // handleSetItemIndexToEdit(-1)
        // toggleFullScreen()
        // handleNewUpdate()
    }
    const getDataValue = (dataValue) => {
        const res = []
        dataValue && dataValue.map((item, index) => {
            res.push({
                "label": item,
                "data": item,
                "color": defaultControl(index),
                "isOpen": false
            })
        })
        return res
    }


    const predefinedFilters = {

    };
    const handleEditDateRangeModal = () => {
        if(!isEditDateRange && item.editedGridCellData) {
            warningAlert()
        } else {
            setFilterIndex(null)
            setIsEditDateRange(!isEditDateRange)
        }
    }

    const currentYear1 = new Date().getFullYear();
    const currentYear2 = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    const [filterIndex, setFilterIndex] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [filterName, setFilterName] = useState(null);
    const [filterColumnHeader, setFilterColumnHeader] = useState(null)
    const [filter, setFilter] = useState("nofilter")
    const [filter2, setFilter2] = useState("nofilter")
    const [selectedColumn, setselectedColumn] = useState("");
    const [selectedDate2, setSelectedDate2] = useState(currentYear2 - 1);

    const [isWithDate2, setIsWithDate2] = useState(false)
    const [isWithDynamicQuery, setIsWithDynamicQuery] = useState(false)

    const [toggleDateRanges, setToggleDateRanges] = useState(false)
    const [dateRangeToEdit, setDateRangeToEdit] = useState(null)

    const [groupedFilters, setGroupedFilters] = useState([])

    useEffect(() => {
        if (filterIndex !== "") {
            const index = parseInt(filterIndex, 10); // Convert string index to number
            const selectedFilter = evaDateFilters[index];

            if (selectedFilter) {
                setFilterName(selectedFilter?.date_name);
                setFilter(selectedFilter?.filter_info)
                setFilterColumnHeader(selectedFilter?.column_header)
            }
        }
    }, [filterIndex]);
    useEffect(() => {
        setFilterIndex(null)
    }, [selectedCategory])
    useEffect(() => {
        const groupedFilters = [];
        evaDateFilters.forEach((filter, index) => {
            const {
              category,
              sub_category = '',
              period_type = '',
              date_name
            } = filter;
            
            const groupLabel = category;
            let group = groupedFilters.find(g => g.label === groupLabel);

            if (!group) {   
                group = {
                    label: groupLabel,
                    items: []
                };
                groupedFilters.push(group);
            }
            
            const periodGroupLabel = period_type;
            let periodGroup = group.items.find(g => g?.label === periodGroupLabel);

            if(!periodGroup) {
                const subGroup = {
                    label: period_type,
                    items: [{ index, date_name }]
                }
                group.items.push(subGroup)
            } else  periodGroup.items.push({ index, date_name });
        });

        setGroupedFilters(groupedFilters)

        if(item && item?.dynamic_query)
        {
            setIsWithDynamicQuery(true)
            if (/\[date2\]/.test(item.dynamic_query)) setIsWithDate2(true)
            else setIsWithDate2(false)
        } else {
            setIsWithDate2(false)
            setIsWithDynamicQuery(false)
        }
    },[item])

    const handleSelectDateFilter = (name, index) => {
        setToggleDateRanges(!toggleDateRanges)
    }
    const [dateRanges, setDateRanges] = useState([])
    const handleApply = () => {
        const newDateRange = {
            item: dateRangeToEdit,
            filter: filter,
            filterColumnHeader: filterColumnHeader,
            my_row_id: item.my_row_id
        }

        setDateRanges((prevDateRanges) => {
            const existingIndex = prevDateRanges.findIndex((d) => d.item === newDateRange.item)

            if(existingIndex !== -1) {
                return prevDateRanges.map((d, index) => 
                    index === existingIndex ? newDateRange : d
                )
            } else {
                return [...prevDateRanges, newDateRange]
            }
        })
        setSelectedCategory(null)
        handleEditDateRangeModal()
    };

    useEffect(() => {
        if (!dateRanges?.length) return;
        try {
            const originalFinalSelectedTemplateItem = templateFinalSelectedTemplateItem
            let updatedQuery 
            let currDateRanges = dateRanges
            if(item.visual_type === "Card") {
                const rowId = item.my_row_id
                const firstRowItem = originalFinalSelectedTemplateItem.find(i => i.my_row_id === rowId)
                currDateRanges = firstRowItem.dateRanges ? 
                    [...dateRanges.filter(d => !firstRowItem.dateRanges.some(id => id.item === d.item)), 
                     ...firstRowItem.dateRanges.filter(id => !dateRanges.some(d => d.item === id.item)),
                     ...dateRanges.filter(d => firstRowItem.dateRanges.some(id => id.item === d.item))] 
                    : dateRanges;

                updatedQuery = firstRowItem.dynamic_query || firstRowItem.query;
            } else {
                updatedQuery = item.dynamic_query || item.query;
            }

            removeDashboardDataStorage(item)

            currDateRanges.forEach(({ item, filter, filterColumnHeader }) => {
                const numMatch = item.match(/\d+/);
                if (!numMatch) return;
            
                const num = numMatch[0];
            
                // Replace full line: SET @date_filterX = ...
                const dateFilterRegex = new RegExp(`SET\\s+@date_filter${num}\\s*=\\s*[^;]*;`, 'g');
                updatedQuery = updatedQuery.replace(
                    dateFilterRegex,
                    `SET @date_filter${num} = '${filter.replace(/'/g, "''")}';`
                );
            
                // Replace full line: SET @column_headerX = ...
                const columnHeaderRegex = new RegExp(`SET\\s+@column_header${num}\\s*=\\s*[^;]*;`, 'g');
                updatedQuery = updatedQuery.replace(
                    columnHeaderRegex,
                    `SET @column_header${num} = ${filterColumnHeader};`
                );
            });
            // Replace `"[dateX]"` (including quotes) with corresponding filter values
            updatedQuery = updatedQuery.replace(/"\[date(\d+)\]"/g, (match, num) => {
                const matchingRange = currDateRanges.find((d) => d.item === `[date${num}]`);
                return matchingRange ? `"${matchingRange.filter}"` : `'nofilter'`;
            });
        
            // Replace `"[headerX]"` (including quotes) with corresponding filterColumnHeader values
            updatedQuery = updatedQuery.replace(/"\[header(\d+)\]"/g, (match, num) => {
                const matchingRange = currDateRanges.find((d) => d.item === `[date${num}]`);
                return matchingRange ? `${matchingRange.filterColumnHeader || match}` : match;
            });
            
            
            setEVAQuery(updatedQuery);
            item.dateRanges = currDateRanges

            if(item.visual_type === "Card") {
                const updatedTemplateItems = originalFinalSelectedTemplateItem.map((i) => {
                    if (i.my_row_id === item.my_row_id) {
                        return { ...i, final_dynamic_query: updatedQuery, dateRanges: currDateRanges };
                    }
                    return i;
                });
                // console.log(updatedTemplateItems)
                setTemplateFinalSelectedTemplateItem(updatedTemplateItems);
                handleDateRangesUpdate()
            }
        } catch (err) {
            setEVAQuery(item.dynamic_query);
        }
    }, [dateRanges]);
    
    function capitalizeFirstLetter(str) {
        try{
            return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        }catch {
            return ""
        }
    }

    const handleToggleDateRanges = (index) => {
        const selectedColumnHeader = gridHeaderWithDateRange[index]
        const extractedDates = selectedColumnHeader.match(/\[date\d+\]/g)
        if(extractedDates) 
        {
            handleEditDateRangeModal();
            setselectedColumn(gridHeader[index]);
        }
        setDateRangeToEdit(extractedDates ? extractedDates[0] : null); 
    }
    useEffect(() => {
    },[selectedCategory])

    const validateCondition = (index) => {
        const da = evaDateFilters[index]
        if(!da?.filter_info) return true
        return false
    }
    const ItemContentView = () => {
        return (
            // !isError ? 
            <>
            <div className='dashboardTemplateItemContainer' style={{ display: 'block', maxHeight: 'none', height: '100%' }}>
                {loading ? <CustomSpinner /> :
                (sqlresult && sqlresult.length > 0) || (gridHeader && gridHeader.length > 0) ? 
                <>
                 {selectedViewOption !== 'Card' ?
                    <div className='templateVisualHeader'>
                        <>
                        <div className='leftContent'>
                            {
                                item.name ? capitalize(item.name) : `Item ${index + 1}`
                            }
                        </div>
                        {sqlresult && sqlresult.length > 0 &&
                            <div className='rightContent'
                                onClick={() => onHandleEditVisual(item.my_row_id, evaQuery)}>
                                <span>Edit Visual</span>
                            </div>
                        }
                        </>
                    </div>
                    :
                    <div className='templateVisualHeader' style={{ position: 'fixed', top: 4, padding: '0px', height: 36, zIndex: 1000, marginRight: 0 }}>
                        {sqlresult && sqlresult.length > 0 &&
                            <div className='rightContent' style={{ padding: '4px' }}
                                onClick={() => onHandleEditVisual(item.my_row_id, evaQuery)}>
                                {/* <span>Edit Visual</span> */}
                                <IconEdit stroke={"#333"} />
                            </div>
                        }
                    </div>
                }
                    <div className='dashboardSettingContainer' style={{ height: 'calc(100% - 40px)'}}>
                        {/* {onEditVisual &&
                            <>
                                <h3 style={{marginBottom: 30}}>{name}</h3>
                                <div className='templateVisualContainer'>
                                    {viewOption.map((item, index) => (
                                        <div 
                                            key={index}
                                            className='templateVisualItem' 
                                            style={selectedViewOption === item ? { backgroundColor : bgColor, color: textColor } : { backgroundColor : '#fafafa', color: bgColor }}
                                            onClick={() => handleSelectViewOption(item)}
                                        >{item}</div>
                                    ))}
                                </div>
                            </>
                        }  */}
                        {isEditDateRange &&
                            <div className='date-range-modal' onClick={() => handleEditDateRangeModal()}>
                                <div className='date-range-body' onClick={(e) => e.stopPropagation()}>
                                    <Row>
                                        <Col xs="12" className="mt-2">
                                            <>
                                                <div className='close-modal' onClick={() => handleEditDateRangeModal()}>
                                                    <IconClose />
                                                </div>
                                                <Label>Select Category</Label>
                                                <Input
                                                    type="select"
                                                    value={selectedCategory}
                                                    onChange={(e) => setSelectedCategory(e.target.value)}
                                                    style={{ marginBottom: 5 }}
                                                >
                                                    <option value="">Select a Category</option>
                                                    {groupedFilters.map((group, groupIndex) => (
                                                        <option key={groupIndex} value={group.label}>
                                                            {group.label}
                                                        </option>
                                                    ))}
                                                </Input>
                                                <Label>Select Date Filter</Label>
                                                <Input
                                                    type="select"
                                                    key={filterIndex}
                                                    value={filterIndex}
                                                    disabled={!selectedCategory || selectedCategory === ""}
                                                    onChange={(e) => setFilterIndex(e.target.value)}
                                                >
                                                    {groupedFilters.map((group, groupIndex) => (
                                                        group.label === selectedCategory &&
                                                        <>
                                                            {group.items.map((subGroup, subIndex) => (
                                                                <optgroup
                                                                    key={`${groupIndex}-${subIndex}`}
                                                                    label={`${subGroup.label}`}
                                                                >
                                                                    <option value="">Select Date Filter</option>
                                                                    {subGroup.items.map((item) => (
                                                                    <option
                                                                        key={`${item.index}-${item.date_name}`}
                                                                        value={item.index}
                                                                        disabled={validateCondition(item.index)}
                                                                    >
                                                                        {validateCondition(item.index) ? "Coming soon | " : ""}{item.date_name}
                                                                    </option>
                                                                    ))}
                                                                </optgroup>
                                                            ))}
                                                        </>
                                                    ))}
                                                </Input>
                                            </>
                                        </Col>
                                        <Col xs='12' className='mt-2'>
                                            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                                <Button color="primary" type="button" size="sm" onClick={handleApply}>
                                                    Apply Filter
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        }
                        
                        <div className='templateGraphContainer'
                            style={{ display: 'block', width: '100%', height: selectedViewOption === 'Card' ? '100%' : 'calc(100% - 45px)', padding: selectedViewOption === 'Card' ? '0px' : '10px 5px' }}>
                            {selectedViewOption === 'Grid' &&
                                <VisualGridView
                                    gridHeader={gridHeader}
                                    gridOriginalHeader={gridOriginalHeader}
                                    gridHeaderWithDateRange={gridHeaderWithDateRange}
                                    sqlresult={sqlresult}
                                    theme={theme}
                                    item={item}
                                    treeViewData={treeViewData}
                                    isWithChild={isWithChild}
                                    isShowGrid={isShowGrid}
                                    toggleAll={toggleAll}
                                    isShowGrap={isShowGrap}
                                    handleSaveVisual={handleSaveVisual}
                                    selectedViewOption={selectedViewOption}
                                    groupLevel={groupLevel}
                                    handleToggleDateRanges={handleToggleDateRanges}
                                />
                            }
                            {selectedViewOption === 'Card' &&
                                <VisualCardView
                                    gridHeader={gridHeader}
                                    gridHeaderWithDateRange={gridHeaderWithDateRange}
                                    sqlresult={sqlresult}
                                    theme={theme}
                                    treeViewData={treeViewData}
                                    isWithChild={isWithChild}
                                    isShowGrid={isShowGrid}
                                    toggleAll={toggleAll}
                                    isShowGrap={isShowGrap}
                                    handleSaveVisual={handleSaveVisual}
                                    templateItemVisual={templateItemVisual}
                                    headerToMultiSelect={headerToMultiSelect}
                                    selectedViewOption={selectedViewOption}
                                    visualType={visualType}
                                    layouts={layout}
                                    index={index}
                                    item={item}
                                    groupLevel={groupLevel}
                                    handleToggleDateRanges={handleToggleDateRanges}
                                />
                            }
                            {(selectedViewOption === 'Bar Chart' || selectedViewOption === 'Line Chart') &&
                                <VisualGraphView
                                    gridHeader={gridHeader}
                                    gridHeaderWithDateRange={gridHeaderWithDateRange}
                                    selectedViewOption={selectedViewOption}
                                    sqlresult={sqlresult}
                                    dataValue={dataValue}
                                    treeViewData={treeViewData}
                                    headerToMultiSelect={headerToMultiSelect}
                                    handleSaveVisual={handleSaveVisual}
                                    templateItemVisual={templateItemVisual}
                                    item={item}
                                    onEditVisual={onEditVisual}
                                    handleCloseEditVisual={handleCloseEditVisual}
                                    groupLevel={groupLevel}
                                    handleToggleDateRanges={handleToggleDateRanges}
                                />
                            }
                            {selectedViewOption === 'Pie Chart' &&
                                <VisualPieChartView
                                    gridHeader={gridHeader}
                                    gridHeaderWithDateRange={gridHeaderWithDateRange}
                                    selectedViewOption={selectedViewOption}
                                    sqlresult={sqlresult}
                                    dataValue={dataValue}
                                    item={item}
                                    treeViewData={treeViewData}
                                    headerToMultiSelect={headerToMultiSelect}
                                    handleSaveVisual={handleSaveVisual}
                                    templateItemVisual={templateItemVisual}
                                    onEditVisual={onEditVisual}
                                    handleCloseEditVisual={handleCloseEditVisual}
                                    groupLevel={groupLevel}
                                    handleToggleDateRanges={handleToggleDateRanges}
                                />
                            }
            
                        </div>
                    </div>
                </>
                :
                <>
                    <div className='templateVisualHeader'>
                        <div className='leftContent'>{item.name}</div>
                    </div>
                    <div className="dashboardItems" style={{
                        height: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center', // Center horizontally
                        justifyContent: 'center', // Center vertically
                        flexWrap: 'wrap'
                    }}>
                        {isError ? 
                        <>
                            <div className="" style={{color: '#ec5c5c', fontWeight: 'bolder', fontSize: 25 }}>MySQL query error</div>
                            <div className="" style={{color: '#ff8383', fontSize: 12, fontWeight: 500, padding: '0px 25px' }}>We couldn’t retrieve the data from MySQL. Please ensure your integration is active.</div>
                        </>
                        :
                        <>
                            <div className="" style={{color: '#9f9f9f', fontWeight: 'bold'}}>No data found</div>
                            <div className="" style={{color: '#9f9f9f', fontSize: '13px', fontWeight: 400}}>Please check your integration status</div>
                        </>
                        }
                        
                    </div>
                </>
                }
            </div>
            </>
            // :
            // <>
            //     <div className="dashboardItems" style={{
            //         height: '200px',
            //         display: 'flex',
            //         flexDirection: 'column',
            //         alignItems: 'center', 
            //         justifyContent: 'center', 
            //         flexWrap: 'wrap'
            //     }}>
            //         <div className="dashboardItemError" style={{color: '#9f9f9f'}}>No data found</div>
            //         <div className="dashboardItemError" style={{color: '#9f9f9f', fontSize: '13px', fontWeight: 400}}>Please check your integration status</div>
            //     </div>
            // </>
            
        )
    }
    const ItemFullScreenView = () => {
        return (
            <div className='ItemFullScreenViewContainer'>
                <div  className='ItemFullScreenViewContent'>
                    <ItemContentView />
                </div>
            </div>
        )
    }
    const warningAlert = () => {
        setAlert(
            <ReactBSAlert
                // warning
                title="Warning"
                onConfirm={() => {
                    setAlert(null)
                    setFilterIndex(null)
                    setIsEditDateRange(!isEditDateRange)
                }}
                onCancel={() => {
                    setAlert(null)
                }}
                confirmBtnBsStyle="primary"
                confirmBtnText="Proceed"
                btnSize=""
                showCancel={true}
            >
                <p>
                    This dashboard item has edited data that may not align correctly if the date range is changed.
                    Proceeding could cause formulas or values to break.
                </p>
                <p style={{ fontWeight: "bold" }}>
                    Do you want to continue anyway?
                </p>
            </ReactBSAlert>
        );
    };
    return (
        <>
            {alert}
            {isFullScreen ? 
            <ItemFullScreenView /> :
            <ItemContentView />}
        </>
        // </Col>
    )
}